const Graph = require('graph-netecs/js/BarGraph/Graph').Graph;

class octaveGraphs {
    constructor(html, store, data, graphs) {
        if (html) {
            this.html = html;
            this.html.innerHTML = "";
        }
        this.store = store;
        this.data = data;
        this.graphs = graphs;

        /*
        NVS-29
        Wykresy oktawalne
        Korzystamy z wykresów słupkowych zdefiniowanych w bibliotece graph-netecs

        TŁUMACZENIA
            octave-graphs - Dane dotyczące hałasu wentylatora w punkcie pracy
            noise-inlet - Poziom ciśnienia akustycznego przy wolnym wlocie/wylocie (1m)
            noise-inlet-octave - Poziom ciśnienia akustycznego w oktawach przy wolnym wlocie/wylocie (1m)
            noise-housing - Poziom ciśnienia akustycznego obudowy (1m)*
            noise-housing-octave - Poziom ciśnienia akustycznego obudowy (1m) w oktawach
            noise-channel - Ogólny poziom mocy akustycznej wentylatora
            noise-channel-octave - Ogólny poziom mocy akustycznej wentylatora w oktawach

            oct - okt
            noise-tolerancy - Wartości hałasu +/- 5dB łącznie z silnikiem
            noise-octave-frequency - Częstotliwość oktawy

            noise-channel-inlet – Poziom mocy akustycznej w kanale ssącym
            noise-channel-octave-inlet – Poziom mocy akustycznej w kanale ssącym w oktawach
            noise-channel-outlet – Poziom mocy akustycznej w kanale tłocznym
            noise-channel-octave-outlet – Poziom mocy akustycznej w kanale tłocznym w oktawach
            noise-housing-soundproofing - Poziom ciśnienia akustycznego obudowy z wygłuszeniem (1m)
            noise-housing-soundproofing-octave - Poziom ciśnienia akustycznego obudowy z wygłuszeniem (1m) w oktawach

        Wszystko zależy od
        this.data.data.octave_graphs_enabled - 0 lub 1

        HAŁAS W PUNKCIE PRACY:
        this.data.params.noise
        */
        if (parseInt(this.data.data.octave_graphs_enabled)) {

            if (parseInt(this.data.data.octave_graphs_la56) && this.graphs.includes('la56')) {
                let nc_a56_noises = this.calculateNoises('la56')
                if (nc_a56_noises.main != 0 && !isNaN(nc_a56_noises.main) && nc_a56_noises.main != Infinity) {
                    let graph_a56 = new Graph(nc_a56_noises.octaves, {
                        title: [
                            this.translate('noise-inlet'),
                            `L<sub>A6</sub>`,
                            `${nc_a56_noises.main} dB(A)`
                        ],
                        plane: {
                            height: 180
                        },
                        yLabel: [
                            this.translate('noise-inlet-octave'),
                            `L<sub>A6 ${this.translate('oct')}</sub>`,
                            `dB(A)`
                        ], 
                        xLabel: this.translate('noise-octave-frequency')
                    })
                    html.appendChild(graph_a56.html)
                }
            }

            if (parseInt(this.data.data.octave_graphs_lpa) && this.graphs.includes('lpa')) {
                let nc_pa_noises = this.calculateNoises('lpa')
                if (nc_pa_noises.main != 0 && !isNaN(nc_pa_noises.main) && nc_pa_noises.main != Infinity) {
                    let graph_pa = new Graph(nc_pa_noises.octaves, {
                        title: [
                            this.translate('noise-housing') + '*',
                            `L<sub>pA</sub>`,
                            `${nc_pa_noises.main} dB(A)`
                        ],
                        plane: {
                            height: 180
                        },
                        yLabel: [
                            this.translate('noise-housing-octave'),
                            `L<sub>pA ${this.translate('oct')}</sub>`,
                            `dB(A)`
                        ], 
                        xLabel: this.translate('noise-octave-frequency'),
                        legend: '* ' + this.translate('theoretical-noise-value') + ' ' + this.translate('engine-sound-value')
                    })
                    html.appendChild(graph_pa.html)
                }
            }
            
            if (parseInt(this.data.data.octave_graphs_lpa) && this.graphs.includes('lpa_prim')) {
                let nc_pa_prim_noises = this.calculateNoises('lpa_prim')
                if (nc_pa_prim_noises.main != 0 && !isNaN(nc_pa_prim_noises.main) && nc_pa_prim_noises.main != Infinity) {
                    let graph_pa = new Graph(nc_pa_prim_noises.octaves, {
                        title: [
                            this.translate('noise-housing-soundproofing') + '*',
                            `L<sub>pA</sub>'/L<sub>pA</sub>"`,
                            `${nc_pa_prim_noises.main}'/${nc_pa_prim_noises.main_second}" dB(A)`
                        ],
                        subtitle: [
                            '',
                            `L<sub>eA</sub>`,
                            `${nc_pa_prim_noises.engineNoise} dB(A)`
                        ],
                        plane: {
                            height: 180
                        },
                        yLabel: [
                            this.translate('noise-housing-soundproofing-octave'),
                            `L<sub>pA</sub>'/L<sub>pA</sub>" <sub>${this.translate('oct')}</sub>`,
                            `dB(A)`
                        ], 
                        xLabel: this.translate('noise-octave-frequency'),
                        legend: '* ' + this.translate('theoretical-noise-value') + ' ' + this.translate('engine-sound-value-soundproofing') + '<br>&nbsp;&nbsp;&nbsp;' + this.translate('lpa-prim-legend')
                    })
                    html.appendChild(graph_pa.html)
                }
            }

            if (parseInt(this.data.data.octave_graphs_lwa34) && this.graphs.includes('lwa')) {
                let nc_wa_noises = this.calculateNoises('lwa')
                if (nc_wa_noises.main != 0 && !isNaN(nc_wa_noises.main) && nc_wa_noises.main != Infinity) {
                    let graph_wa = new Graph(nc_wa_noises.octaves, {
                        title: [
                            this.translate('noise-channel') + '*',
                            `L<sub>WA</sub>`,
                            `${nc_wa_noises.main} dB(A)`
                        ],
                        plane: {
                            height: 180
                        },
                        yLabel: [
                            this.translate('noise-channel-octave'),
                            `L<sub>WA ${this.translate('oct')}</sub>`,
                            `dB(A)`
                        ], 
                        xLabel: this.translate('noise-octave-frequency'),
                        legend: '* ' + this.translate('theoretical-noise-value')
                    })
                    html.appendChild(graph_wa.html)
                }
            }

            if (parseInt(this.data.data.octave_graphs_lwa34) && this.graphs.includes('lwa3')) {
                let nc_wa3_noises = this.calculateNoises('lwa3')
                if (nc_wa3_noises.main != 0 && !isNaN(nc_wa3_noises.main) && nc_wa3_noises.main != Infinity) {
                    let graph_wa3 = new Graph(nc_wa3_noises.octaves, {
                        title: [
                            this.translate('noise-channel-inlet') + '*',
                            `L<sub>WA3</sub>`,
                            `${nc_wa3_noises.main} dB(A)`
                        ],
                        plane: {
                            height: 180
                        },
                        yLabel: [
                            this.translate('noise-channel-octave-inlet'),
                            `L<sub>WA3 ${this.translate('oct')}</sub>`,
                            `dB(A)`
                        ], 
                        xLabel: this.translate('noise-octave-frequency'),
                        legend: '* ' + this.translate('theoretical-noise-value')
                    })
                    html.appendChild(graph_wa3.html)
                }
            }

            if (parseInt(this.data.data.octave_graphs_lwa34) && this.graphs.includes('lwa4')) {
                let nc_wa4_noises = this.calculateNoises('lwa4')
                if (nc_wa4_noises.main != 0 && !isNaN(nc_wa4_noises.main) && nc_wa4_noises.main != Infinity) {
                    let graph_wa4 = new Graph(nc_wa4_noises.octaves, {
                        title: [
                            this.translate('noise-channel-outlet') + '*',
                            `L<sub>WA4</sub>`,
                            `${nc_wa4_noises.main} dB(A)`
                        ],
                        plane: {
                            height: 180
                        },
                        yLabel: [
                            this.translate('noise-channel-octave-outlet'),
                            `L<sub>WA4 ${this.translate('oct')}</sub>`,
                            `dB(A)`
                        ], 
                        xLabel: this.translate('noise-octave-frequency'),
                        legend: '* ' + this.translate('theoretical-noise-value')
                    })
                    html.appendChild(graph_wa4.html)
                }
            }
        }
    }

    calculateNoises(type) {
        const engineNoise = Number(this.data.engine.noise);
        const ratedSpeed = ((this.store.state.workPointParameters.elements["work_frequency"].value / 50) * this.store.state.activeFun.data.avg_nominal_speed).toFixed(0);
        const totalPressure = Number(this.store.state.workPointParameters.elements.total_pressure.value._oryginal);
        const performance = this.store.state.workPointParameters.elements.performance.value / this.store.state.workPointParameters.elements.number_of_fans.value;
        // NVS-218 - zmiana źródła wymiarów obudowy
        const a = parseInt(this.store.state.activeFun.selectedFanData.external_dimensions.split('x')[0]) / 1000;
        const b = parseInt(this.store.state.activeFun.selectedFanData.external_dimensions.split('x')[1]) / 1000;
        const c = (120 + parseFloat(this.store.state.activeFun.data.outlet_b) + parseFloat(this.store.state.activeFun.engine.lb_motor_length)) / 1000;
        const measure_surface = 10 * Math.log10(2 * (a * b + a * c + b * c) + 4 * (a + b + c) + 4 * 3.14);
        let octaves = [];
        let octaves_second = [];
        let main = 0;
        let main_second = 0;

        // NVS-211 - metoda do liczenia niezwykle skomplikowanej sumy ;-)
        const sum = (arr) => 10 * Math.log10(arr.reduce((total, item) => total + Math.pow(10, item.value / 10), 0));

        // NVS-211 - metoda do rozbijania na oktawy
        const toOctaves = (noise) => {
            const octaves = [];
            for (const [key, value] of Object.entries(Object.entries(Object.entries(this.store.state.OctaveNoiseList).find(item => item[1].rpm == Math.ceil(ratedSpeed / 50) * 50))[1][1])) {
                if(key.startsWith('l_')) {
                    octaves.push({ key, label: `${key.match(/\d+/)[0]} Hz`, value: noise - value });
                }
            }
            return octaves;
        }

        // NVS-211 - obliczamy LWA w funkcji bo jest potrzebne w 3 wykresach, ta sama funkcja musi być w fanObjParamsManager.js
        const calculateLwa = () => {
            const noise = 9 * Math.log10(performance) + 20 * Math.log10(totalPressure) + 10 * Math.log10(ratedSpeed);
            let octaves = toOctaves(noise);

            const p2 = Object.entries(Object.entries(this.store.state.OctaveNoiseLwaList).find(item => item[1].name == 'p2'))[1][1];
            if (!p2) {
                return { noise: 0, octaves: [] };
            }
            octaves = octaves.map(item => ({ ...item, value: item.value - Number(p2[item.key]) }));
            octaves = octaves.map(item => ({ ...item, value: item.value + (noise - sum(octaves)) + Number(p2[item.key]) }));

            return { noise: sum(octaves), octaves };
        };

        // NVS-211 - obliczmy LPA w funkcji bo jest potrzebne w 2 wykresach
        const calculateLpa = () => {
            const noise = 10 * Math.log10(Math.pow(10, (this.store.state.workPointParameters.elements.noise.value._oryginal - 9 * Math.log10(engineNoise)) / 10) + Math.pow(10, engineNoise / 10));
            const octaves = toOctaves(noise);

            return { noise, octaves };
        }

        switch (type) {
            case 'la56':
                main = Math.round(this.store.state.workPointParameters.elements.noise.value._oryginal);
                octaves = toOctaves(main).map(item => ({ ...item, value: Math.round(item.value) }));
                break;
            case 'lpa':
                octaves = calculateLpa().octaves.map(item => ({ ...item, value: Math.round(item.value) }));
                main = Math.round(calculateLpa().noise);
                break;
            case 'lpa_prim':
                const pi = Object.entries(Object.entries(this.store.state.OctaveNoiseLwaList).find(item => item[1].name == 'pi'))[1][1];
                if (!pi) {
                    main = 0;
                    break;
                }
                octaves_second = calculateLpa().octaves.map(item => ({ ...item, value: item.value - Number(pi[item.key]) }));
                main_second = Math.round(sum(octaves_second));

                octaves = calculateLpa().octaves;
                main = calculateLpa().noise;
                main = 10 * Math.log10(Math.pow(10, main / 10) - Math.pow(10, engineNoise / 10));
                octaves = toOctaves(main).map(item => ({ ...item, value: item.value - Number(pi[item.key]) }));
                main = sum(octaves);
                main = 10 * Math.log10(Math.pow(10, main / 10) + Math.pow(10, engineNoise / 10));
                main = (main + main_second) / 2; // NVS-214 - zmiana sposobu wyliczania prima, bis bez zmian
                octaves = toOctaves(main).map(item => ({ ...item, value: Math.round(item.value), top_label: `${Math.round(item.value)}'/${Math.round(octaves_second.find(o => o.key == item.key).value)}"` }));
                main = Math.round(main);
                break;
            case 'lwa':
                // NVS-214 - zmiana sposobu liczenia z uwzględnieniem powierzchni pomiarowej
                main = calculateLpa().noise + measure_surface;
                octaves = toOctaves(main).map(item => ({ ...item, value: Math.round(item.value) }));
                main = Math.round(main);
                break;
            case 'lwa3':
                const p3 = Object.entries(Object.entries(this.store.state.OctaveNoiseLwaList).find(item => item[1].name == 'p3'))[1][1];
                if (!p3) {
                    main = 0;
                    break;
                }
                octaves = calculateLwa().octaves.map(item => ({ ...item, value: Math.round(item.value - Number(p3[item.key])) }));
                main = Math.round(sum(octaves));
                break;
            case 'lwa4':
                const p4 = Object.entries(Object.entries(this.store.state.OctaveNoiseLwaList).find(item => item[1].name == 'p4'))[1][1];
                if (!p4) {
                    main = 0;
                    break;
                }
                octaves = calculateLwa().octaves.map(item => ({ ...item, value: Math.round(item.value - Number(p4[item.key])) }));
                main = Math.round(sum(octaves));
                break;
        }
        return { octaves, main, octaves_second, main_second, engineNoise };
    }

    translate(code, displayErrors = true) {
        let arg = {
            type: 'translate',
            code: code,
            displayErrors: displayErrors,
            out: ""
        }

        this.store.commit(arg);

        return arg.out;
    }

    round(v, d) {
        return Math.round(v * Math.pow(10, d)) / Math.pow(10, d)
    }
}

export { octaveGraphs };
